import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=09da1b71&scoped=true&"
import script from "./CreatePost.vue?vue&type=script&lang=js&"
export * from "./CreatePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09da1b71",
  null
  
)

export default component.exports